module.exports = __webpack_public_path__ + "static/img/currency.687d8a5e.png";